export default __webpack_public_path__ + "static/media/menu4_hl.cc8d9d80.png";